import { render, staticRenderFns } from "./ReviewDetailCard.vue?vue&type=template&id=2f4a8d7c&scoped=true"
import script from "./ReviewDetailCard.vue?vue&type=script&lang=js"
export * from "./ReviewDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetailCard.vue?vue&type=style&index=0&id=2f4a8d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a8d7c",
  null
  
)

export default component.exports